var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpLowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_3230)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#4D7F2A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0688 25.35C24.8388 23.96 26.3188 23.14 27.1788 21.91C28.0888 20.62 27.5788 18.21 24.9988 18.21C23.3088 18.21 22.4788 19.49 22.1288 20.55L19.5388 19.46C20.2488 17.33 22.1788 15.5 24.9888 15.5C27.3388 15.5 28.9488 16.57 29.7688 17.91C30.4688 19.06 30.8788 21.21 29.7988 22.81C28.5988 24.58 27.4488 25.12 26.8288 26.26C26.5788 26.72 26.4788 27.02 26.4788 28.5H23.5888C23.5788 27.72 23.4588 26.45 24.0688 25.35ZM26.9988 32.5C26.9988 33.6 26.0988 34.5 24.9988 34.5C23.8988 34.5 22.9988 33.6 22.9988 32.5C22.9988 31.4 23.8988 30.5 24.9988 30.5C26.0988 30.5 26.9988 31.4 26.9988 32.5Z",
    fill: "#4D7F2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_3230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpLowIcon);
export default __webpack_public_path__ + "static/media/help_low_icon.f26107b4.svg";
export { ForwardRef as ReactComponent };